
// FILL HOMEPAGE BOTTLE

function mobile_anim() {
  gsap.set('.bottle-water', { height: '0' });
  gsap.to('.bottle-water', {
    height: '80%',
    scrollTrigger: {
      trigger: '.animated-water',
      start: 'top center',
      scrub: 0.3,
      end: 'bottom center',
      markers: false,
      // toggleActions: "play reverse play reverse"
    },
  });
  
  ScrollTrigger.create({
    trigger: '.features',
    start: 'top top',
    end: 'bottom bottom',
    pin: '.animation-wrap',
    pinSpacing: false,
    invalidateOnRefresh: true
  });
  
  const featureImgs = gsap.utils.toArray('.feature__img-wrapper .img-overlay');
  const featureBoxes_2 = document.querySelectorAll('.feature__info_2');
  const featureBoxes = document.querySelectorAll('.feature__info');
  const featureBoxes_mobile = document.querySelectorAll('.feature__info_mobile');

  featureImgs.forEach((img, i) => {
    // Mobile Parallax
    let featureBox_mobile = featureBoxes_mobile[i];
    ScrollTrigger.create({
      trigger: img,
      toggleClass: { targets: featureBox_mobile, className: 'active' },
      start: 'top 50%',
      end: 'bottom 50%',
    });

    gsap
      .timeline({
        scrollTrigger: {
          trigger: img,
          start: 'top 70%',
          end: 'bottom 70%',
          markers: false,
          toggleActions: 'play reverse play reverse',
        },
      })
      .from(featureBox_mobile, {
        autoAlpha: 0,
        y: 20,
        delay: 0.5,
        // y: 20,
        duration: 0.25,
      });
  });
}

function desktop_anim() {
  gsap.set('.bottle-water', { height: '0' });
  gsap.to('.bottle-water', {
    height: '80%',
    scrollTrigger: {
      trigger: '.animated-water',
      start: 'top center',
      scrub: 0.3,
      end: 'bottom center',
      markers: false,
      // toggleActions: "play reverse play reverse"
    },
  });
  
  ScrollTrigger.create({
    trigger: '.features',
    start: 'top top',
    end: 'bottom bottom',
    pin: '.animation-wrap',
    pinSpacing: false,
    invalidateOnRefresh: true
  });
  
  const featureImgs = gsap.utils.toArray('.feature__img-wrapper .img-overlay');
  const featureBoxes_2 = document.querySelectorAll('.feature__info_2');
  const featureBoxes = document.querySelectorAll('.feature__info');
  const featureBoxes_mobile = document.querySelectorAll('.feature__info_mobile'); 

  featureImgs.forEach((img, i) => {
    // Desktop Parallax
    let featureBox = featureBoxes[i];
    ScrollTrigger.create({
      trigger: img,
      toggleClass: { targets: featureBox, className: 'active' },
      start: 'top 50%',
      end: 'bottom 50%',
    });
    let featureBox_2 = featureBoxes_2[i];
    ScrollTrigger.create({
      trigger: img,
      toggleClass: { targets: featureBox_2, className: 'active' },
      start: 'top 50%',
      end: 'bottom 50%',
    });

    gsap
      .timeline({
        scrollTrigger: {
          trigger: img,
          start: 'top 70%',
          end: 'bottom 70%',
          markers: false,
          toggleActions: 'play reverse play reverse',
        },
      })
      .from(featureBox, {
        autoAlpha: 0,
        y: 20,
        delay: 0.5,
        // y: 20,
        duration: 0.25,
      });

    gsap
      .timeline({
        scrollTrigger: {
          trigger: img,
          start: 'top 70%',
          end: 'bottom 70%',
          markers: false,
          toggleActions: 'play reverse play reverse',
        },
      })
      .from(featureBox_2, {
        autoAlpha: 0,
        y: 20,
        delay: 0.5,
        // y: 20,
        duration: 0.25,
      });
});
}


if ($(window).width() < 1240) {
  mobile_anim();
} else {
  desktop_anim();
}


var id;
$(window).on('resize', function(){
  clearTimeout(id);
  id = setTimeout(doneResizing, 500);
  ScrollTrigger.refresh()
});

function doneResizing(){
  if ($(window).width() >= 1240) {
    desktop_anim();
  } else {
    mobile_anim();
  }
}